import { compact, map, filter, every, isEmpty, some, get, toLower, toString } from 'lodash'

const filteredVMData = ({ devices: customers, filters }) => compact(map(customers, (customer) => {
  const devices = filter(customer.devices, device => {
    const filterResults = {}

    if (filters.locations != 'All') {
      filterResults['locations'] = some(filters.locations, location => location.value === get(device, 'location'))
    }
    if (filters.clusters != 'All') {
      filterResults['clusters'] = some(filters.clusters, cluster => cluster.value === get(device, 'cluster'))
    }
    if (filters.dataProtection != 'All') {
      filterResults['dataProtection'] = some(filters.dataProtection, dataProtection => toLower(dataProtection.value) === toLower(get(device, 'in_data_protection')))
    }
    if (filters.monitoring != 'All') {
      filterResults['monitoring'] = some(filters.monitoring, monitoring => toLower(monitoring.value) === toLower(get(device, 'in_monitoring')))
    }
    if (filters.antiVirus != 'All') {
      filterResults['antiVirus'] = some(filters.antiVirus, antiVirus => antiVirus.value === get(device, 'antivirus_status'))
    }
    if (filters.patching != 'All') {
      filterResults['patching'] = some(filters.patching, patching => patching.value === get(device, 'patching_status'))
    }

    if (filters.calligoManagement != 'All') {
      filterResults['calligoManagement'] = some(
        filters.calligoManagement,
        calligoManagement => calligoManagement.value === toString(get(device, 'calligo_management'))
      )
    }

    if (filters.deviceTypes != 'All') {
      filterResults['deviceTypes'] = some(filters.deviceTypes, deviceType => deviceType.value === get(device, 'device_type'))
    }

    if (filters.powerState != 'All') {
      filterResults['powerState'] = filters.powerState === toString(get(device, 'power_state'))
    }

    if (filters.encryption != 'All') {
      filterResults['encryption'] = some(
        filters.encryption,
        encryption => toString(encryption.value) === toString(get(device, 'encyptionEnabled'))
      )
    }

    if (filters.passwordPolicyStrength != 'All') {
      filterResults['passwordPolicyStrength'] = some(
        filters.passwordPolicyStrength,
        passwordPolicyStrength => toString(passwordPolicyStrength.value) === toString(get(device, 'passwordPolicyStrength'))
      )
    }

    if (filters.firewall != 'All') {
      filterResults['firewall'] = some(
        filters.firewall,
        firewall => toString(firewall.value) === toString(get(device, 'firewallStatus'))
      )
    }

    if (filters.cve != 'All') {
      filterResults['cve'] = some(
        filters.cve,
        cve => device.cve[cve.value] !== 0
      )
    }

    return (every(filterResults, (value, key) => value === true) || isEmpty(filterResults))
  })

  if (devices.length == 0) { return null }
  return { ...customer, devices }
}))

export default filteredVMData
export { filteredVMData }
